import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';
import VueTextareaAutosize from 'vue-textarea-autosize'
import VTooltip from 'v-tooltip'
import VueI18n from 'vue-i18n'
import messages from '@/common/i18n/messages'

import './assets/scss/main.scss'
import "vue-custom-scrollbar/dist/vueScrollbar.css"
import './assets/scss/cropper.css'
import './filters'
import YmapPlugin from 'vue-yandex-maps'

Vue.use(YmapPlugin)
Vue.use(VueI18n)
Vue.use(VueTextareaAutosize)
Vue.use(VTooltip)

export const eventBus = new Vue()

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'sl',
  messages
})

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
